import { AppTable } from '../../../../components';
import { RateListHook } from '../../../../hooks/rate';
import { RateRow } from '../../../../page-components/settings';

export function RateList() {
  const { data, loading, totalData, totalPages, filter, filterChanged, pageChanged } =
    RateListHook();

  const columns = [
    {
      text: 'Name',
      key: 'name',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Warehouse',
      key: 'warehouse',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Created At',
      key: 'created_at',
      width: 2,
      textAlign: 'left',
    },
    {
      text: 'Description',
      key: 'description',
      width: 3,
      textAlign: 'left',
    },
    {
      text: 'Active',
      key: 'active',
      width: 2,
      textAlign: 'left',
    },
    {
      text: '',
      key: 'action',
      width: 2,
      textAlign: 'left',
    },
  ];

  return (
    <div>
      <AppTable
        columns={columns}
        data={data}
        loading={loading}
        totalData={totalData}
        totalPages={totalPages}
        RowComponent={<RateRow />}
        currentPage={filter.page}
        pageSizeChanged={size => filterChanged('limit', size)}
        pageSize={filter.limit}
        pageChanged={pageChanged}
      />
    </div>
  );
}
